// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"7eb5d060","455":"01ac070b"}[chunkId] + ".chunk.js";
};